// this is responsible for global state for
// leftButtons, centerButtons, requiresAction, etc.
// mutate the global singleton via angular service

export default function() {
  return {
    leftButtons: {},
    centerButtons: {},
    requiresActions: false,
  }
}
